<template>
  <div v-if="model && !isLoading">
    <app-toolbar :crumbs="crumbs">
      <v-btn
        plain
        :to="{ name: 'person-detail', params: { personId: model.personId } }"
      >
        Tracker
      </v-btn>
    </app-toolbar>

    <div>
      <person-form
        v-model="model"
        :collection="collection"
        @cancel="onCancel"
        @delete="onDelete"
        @save="onSave"
      ></person-form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import appToolbar from '@/components/layout/app-toolbar'
import collectionApi from '@/services/api/collection'
import personApiBuilder from '@/services/api/collection-person'
import personForm from './form'

export default {
  components: { appToolbar, personForm },
  data() {
    return {
      isLoading: true,
      collection: null,
      personApi: null,
      model: {}
    }
  },
  computed: {
    crumbs() {
      const items = [
        {
          text: this.$t('collections'),
          to: { name: 'collections-index' },
          disabled: false
        }
      ]

      if (this.collection) {
        items.push({
          text: this.collection.collectionNumber,
          to: {
            name: 'collection-detail',
            params: { collectionId: this.collectionId }
          },
          disabled: false
        })
      }

      items.push({ text: this.$t('person'), disabled: true })
      return items
    },
    collectionId() {
      return this.$route.params.collectionId
    },
    personId() {
      return this.$route.params.personId
    }
  },
  async mounted() {
    this.personApi = personApiBuilder.build(this.collectionId)
    this.collection = await collectionApi.fetch(this.collectionId)
    this.model = await this.personApi.fetch(this.personId)
    this.isLoading = false
  },
  methods: {
    ...mapActions('messages', ['addMessage']),
    onCancel() {
      this.returnToCollection()
    },
    async onDelete() {
      await this.personApi.delete(this.personId)
      this.addMessage({
        message: `${this.$t('person')} '${this.model.name}' ${this.$t('hasBeenDeleted')}`
      })
      this.returnToCollection()
    },
    async onSave(item) {
      await this.personApi.put(this.personId, item)
      this.addMessage({
        message: `${this.$t('person')} '${item.name}' ${this.$t('hasBeenUpdated')}`
      })
      this.returnToCollection()
    },
    returnToCollection() {
      this.$router.push({
        name: 'collection-detail',
        params: { collectionId: this.collectionId }
      })
    }
  }
}
</script>

<style></style>
